import React, { FC, Fragment } from 'react';
import { theme } from '../tailwind.config';
import Icon from '@components/Icon';
import Hexagon from './Hexagon';

const ProgressBar: FC<{
  activeIndex?: number;
  steps: string[];
  shouldRenderCheck: (index: number) => boolean;
}> = ({ steps, activeIndex = 0, shouldRenderCheck }) => {
  const renderStep = (title: string, index: number) => (
    <div className="relative">
      <Hexagon
        size={16}
        hexagonColor={
          index <= activeIndex ? theme.colors.blue : theme.colors['lightGray']
        }
      >
        {shouldRenderCheck(index) && <Icon.Check title="checkmark" />}
      </Hexagon>
      <div
        className={`absolute left-1/2 transform -translate-x-1/2 ${
          index <= activeIndex ? 'text-blue' : 'text-lightGray'
        } mt-0.5 text-micro`}
      >
        {title}
      </div>
    </div>
  );

  return (
    // text-left ensures the hexagons do not get messed up by any text-center in the parent
    <div className="h-progressBarHeight text-left">
      <div className="flex flex-row items-center">
        {steps.map((stepTitle, i) => (
          <Fragment key={stepTitle}>
            {i > 0 && (
              <div
                className={`flex-1 h-progressBarTrackHeight ${
                  i <= activeIndex ? 'bg-blue' : 'bg-lightGray'
                }`}
              />
            )}
            {renderStep(stepTitle, i)}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
